import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/** Facebook Feed on desktop ("Novosti na stolnome računalu"). */
@Component({
  selector: 'app-meta-facebook-feed-desktop',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './facebook-feed-desktop.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/facebook/facebook-feed-styles.scss',
    './facebook-feed-desktop.component.scss',
  ]
})
export class MetaFacebookFeedDesktopPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /**
   * Desktop shows the whole primary text (150 characters at most), one block
   * per paragraph so the gap between them matches the mock.
   */
  get paragraphs(): string[] {
    return MetaPreviewCopy.primaryText(this.data)
      .split(/\r?\n/)
      .filter((line) => line.trim() !== '');
  }

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get domain(): string {
    return MetaPreviewCopy.domain(this.data);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
